import { Injectable } from '@angular/core';

@Injectable()
export class ConfigService {

  _apiURI: string;
  _baseURI: string;
  _subDomainClient: string;
  environmentName: string = "test";
  testClientId: number = 158;//for local use required client-id IMVO:175, LEAK:157, XPRO:158, IGNT: 174
  contractorId: string;

  constructor() {
    var url = window.location.href;
    var arr = url.split("/");
    var host = window.location.host;

    this._baseURI = window.location.href.split('/').slice(0, 3).join('/');
    this._subDomainClient = host.split('.')[0];
    //console.log(this.environmentName);
    if (this.environmentName == "local") {
      this._apiURI = 'http://localhost:5000/api';
      //this._apiURI = this._baseURI + "/api";
    }
    else if (this.environmentName == "test") {
      //this._apiURI = 'https://portaldev.qubesense.com/api';
      this._apiURI = this._baseURI + "/api";
    }
    else if (this.environmentName == "prod") {
      //this._apiURI = 'https://portal.qubesense.com/api';
      this._apiURI = this._baseURI + "/api";
    }    
  }

  getApiURI() {
    return this._apiURI;
  }

  getBaseApiURI() {
    return this._baseURI;
  }

  getSubdomain() {
    //console.log(this._subDomainClient);
    return this._subDomainClient;
  }

  // Get ContractorId
  getContractorId() {
    return this.contractorId = localStorage.getItem("contractorId");
  }

  getEmportalAPIUrl() {
    if (this.environmentName != "prod") {
      return "https://emportalapitest.azurewebsites.net"; //test
    }
    else {
      return "https://emportalapi.qubesense.com"; //prod
    }
    
  }

}
